export default __webpack_public_path__ + "static/media/EventReg-Birthday.a1929de3.svg";